import Vue from 'vue'
import Vuex from 'vuex'
import cacheComs from './modules/cacheComs'
import passport from './modules/passport'
import permission from './modules/permission'
import getters from './getters'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    cacheComs,
    passport,
    permission
  },
  getters,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js